import { render, staticRenderFns } from "./DeparturesPageSaoMateus.vue?vue&type=template&id=984d337c&"
import script from "./DeparturesPageSaoMateus.vue?vue&type=script&lang=js&"
export * from "./DeparturesPageSaoMateus.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesPageSaoMateus.vue?vue&type=style&index=0&id=984d337c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports